import styled from "styled-components";

export const StyledCard = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 350px;

  background-color: var(--dark--gray--50);
  border-radius: 20px;
  margin: 20px;


  p,h1,span,svg{
    background-color: var(--dark--gray--50);
    color: var(--dark--primary--text);
  }

  a{
    color: var(--dark--links);
    background-color: var(--dark--gray--50);
  }

  div{
    background-color: var(--dark--gray--50);
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }

  .projectInfo{
    height: 522px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  img {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }

  h1{
    text-align: center;
    font-size: 1.75rem;
    margin-top: 1.688rem;
    margin-bottom: 1.063rem;
  }

  .description{
    text-align: justify;
    padding: 0 31px 12px 28px;
    font-size: 1.125rem;
  }

  .techStack{
    text-align: start;
    padding: 0 31px 21px 28px;
    font-size: 1rem;
  }

  .icon{
    color: var(--dark--green--50);
  }

  svg{
    font-size: 1.25rem;
  }

  .externLinks{
    display: flex;
    width: 100%;
    justify-content: space-around;
    margin-bottom: 25px;

    div{
      display: flex;
      width: 50%;
      align-items: center;
      justify-content: center;
      
      a{
        margin-left: 1rem;
        font-size: 1rem;
        text-decoration: underline;
      }
    }
  }
`;
